import { Component, OnInit } from '@angular/core';
import { LazySelectableTableComponent } from 'src/app/shared/primeng/abstract-classes/lazy-selectable-table.component';
import { DatagridService, PagedResultGeneric, TranslationService, LocalStorageService, NotificationService } from 'src/app/shared';
import { DataQueryService } from '../shared/data-query.service';
import { DataQuerySearchDto } from '../shared/dto/data-query-search.dto';
import { DataQueryDto } from '../shared/dto/data-query.dto';
import { SelectItem } from 'primeng/api';
import { ProfileSearchParameterService } from 'src/app/profiles/shared/profile-search-parameter.service';
import { ProfileAdvancedSearchParams } from 'src/app/profiles/search/profile-advanced-search-params.model';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ProfileSearchComponentModel } from 'src/app/profiles/search/profile-search-component.model';

@Component({
  selector: 'wl-report-saved-queries',
  templateUrl: './report-saved-queries.component.html',
  styleUrls: ['./report-saved-queries.component.less'],
  providers: [ProfileSearchParameterService],
    standalone: false
})
export class ReportSavedQueriesComponent extends LazySelectableTableComponent<DataQuerySearchDto, DataQueryDto> implements OnInit {
  pagingSizeItems: SelectItem[] = [];
  showProfileSelectorModal = false;
  showDatePrompt = false;
  currentQuery = {} as DataQueryDto;
  queryAction: QueryActionEnum;

  constructor(
    datagridService: DatagridService,
    private _dataQueryService: DataQueryService,
    private _navigationService: NavigationService,
    private _notificationService: NotificationService,
    private _profileSearchParameterService: ProfileSearchParameterService,
    private _translationService: TranslationService
  ) {
    super('Id', datagridService);
    this.searchParams = { IncludeXml: false } as DataQuerySearchDto;
  }

  async ngOnInit(): Promise<void> {
    this.pagingSizeItems = [
      {
        label: await this._translationService.getTitlecase('common.page-size.show-20'),
        value: 20,
      },
      {
        label: await this._translationService.getTitlecase('common.page-size.show-100'),
        value: 100,
      },
      {
        label: await this._translationService.getTitlecase('common.page-size.show-all'),
        value: 9999,
      },
    ];
  }

  async exportQuery(savedQuery: DataQueryDto) {
    if ((savedQuery.DateParameters?.length ?? 0) > 0) {
      this.currentQuery = savedQuery;
      this.queryAction = QueryActionEnum.Export;
      this.showDatePrompt = true;
    } else {
      const url = await this._dataQueryService.exportDataQueryToCsv(savedQuery.Id);
      this._navigationService.popupSafeNavigate(url);
    }
  }

  openInProfileSelector(savedQuery: DataQueryDto) {
    if ((savedQuery.DateParameters?.length ?? 0) > 0) {
      this.queryAction = QueryActionEnum.ViewInProfileSelector;
      this.currentQuery = savedQuery;
      this.showDatePrompt = true;
    } else {
      this._dataQueryService
        .getQueryProfileIds(savedQuery.Id)
        .then((data) => {
          const profileids = data;
          const profileSearchModel = new ProfileSearchComponentModel();
          if (profileids && profileids.length) {
            profileSearchModel.searchParams.PermitProfiles = profileids;
            this._profileSearchParameterService.setProfileSearchResults(profileSearchModel);
            this._profileSearchParameterService.setSearchLoadOptions({ RunOnLoad: true, HideAdvancedParams: true, FromNavigation: true });
            this._navigationService.navigateToProfileFinder();
          } else {
            this._notificationService.translateError('reports.saved-queries.no-results');
          }
        })
        .catch((err: HttpErrorResponse) => {
          this._notificationService.httpError(err);
        });
    }
  }

  pageSizeChanged() {
    this.searchParams.PageNumber = 1;
    this.search();
  }

  fetchResults(): Promise<PagedResultGeneric<DataQueryDto>> {
    this._dataQueryService.getMySavedDataQueries(this.searchParams).then((data: PagedResultGeneric<DataQueryDto>) => {
      const queries = data.Result;
    });

    return this._dataQueryService.getMySavedDataQueries(this.searchParams);
  }

  openEditQuery(savedQuery: DataQueryDto) {
    this._navigationService.navigateToQueryTool(savedQuery.Id);
  }

  async acceptDateParams() {
    this.showDatePrompt = false;
    switch (this.queryAction) {
      case QueryActionEnum.Export:
        const url = await this._dataQueryService.exportDataQueryWithDateParamsToCsv(this.currentQuery);
        this._navigationService.popupSafeNavigate(url);
        break;
      case QueryActionEnum.ViewInProfileSelector:
        this._dataQueryService
          .getQueryProfileIdsWithDates(this.currentQuery)
          .then((data) => {
            const profileids = data;
            const profileSearchModel = new ProfileSearchComponentModel();
            if (profileids && profileids.length) {
              profileSearchModel.searchParams.PermitProfiles = profileids;
              this._profileSearchParameterService.setProfileSearchResults(profileSearchModel);
              this._profileSearchParameterService.setSearchLoadOptions({ RunOnLoad: true, HideAdvancedParams: true, FromNavigation: true });
              this._navigationService.navigateToProfileFinder();
            } else {
              this._notificationService.translateError('reports.saved-queries.no-results');
            }
          })
          .catch((err: HttpErrorResponse) => {
            this._notificationService.httpError(err);
          });
        break;
    }
  }
}

export enum QueryActionEnum {
  Export = 0,
  ViewInProfileSelector = 1,
}
